import React, { useEffect, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import { Container, Input } from "reactstrap";
import { RenderCustomHeader } from "../../share/RenderCustomHeader";
import { ConvertDateToThaiBuddhist } from "../../share/ConvertDateToThaiBuddhist";
import { ConvertDateFormat } from "../../share/ConvertDateFormat";
import DatePicker from "react-datepicker";
// import { Loading } from "../../share/loading";
import 'react-datepicker/dist/react-datepicker.css'
import './Reports.css'
export const FormSelectData = (props) => {
    const { setMeetingNo, setMeetingYear, setMeetingDate } = props;
    // const [loading, setLoading] = useState(false);
    const [meetingNoSelect, setMeetingNoSelect] = useState([]);
    const [meetingYearSelect, setMeetingYearSelect] = useState([])
    useEffect(() => {
        async function GetMeetingForSelect() {
            try {
                let res = await fetch(`api/ProposalBorrow/getMeetingNoSelect`);
                let resJson = await res.json();

                setMeetingNoSelect(resJson.dataenum);
            } catch (e) {
                // console.log("err =>", e)
            }
        }
        GetMeetingForSelect()
    }, [])
    const formInitialValues = {
        meetingNo: "",
        meetingYear: "",
        meetingDate: ""
    }
    return (
        <Formik
            initialValues={formInitialValues}
            enableReinitialize
        >
            {(formikSelect) => {
                // console.log("formikSelect", formikSelect)
                async function getYearForSelect(e) {
                    let postData = new FormData()
                    postData.append("meetingNo", e.target.value)
                    // console.log("meetingNo", e.target.value)
                    try {
                        let res = await fetch("api/ProposalBorrow/getMeetingYearSelect", {
                            method: "POST",
                            body: postData
                        })
                        let resJson = await res.json()
                        setMeetingYearSelect(resJson.dataenum)
                    } catch (e) {
                        // console.log("err", e)
                    }
                }
                return (
                    <Container>
                        <Form
                            className="d-flex justify-content-center align-items-center"
                            autoComplete="off"
                        >
                            <div className="d-flex align-items-center justify-content-start w-50 mx-1">
                                <span className="w-75 text-center">ครั้งที่</span>
                                <Input
                                    name="meetingNo"
                                    type="select"
                                    className="text-center w-100 rounded-pill input-color"
                                    onChange={(e) => {
                                        formikSelect.handleChange(e)
                                        getYearForSelect(e)
                                        setMeetingNo(e.target.value)
                                    }}
                                    onBlur={formikSelect.handleBlur}
                                    value={formikSelect.values.meetingNo}
                                >
                                    <option defaultValue={"กรุณาเลือก"}>
                                        กรุณาเลือก
                                    </option>
                                    {meetingNoSelect.map((item, k) => (
                                        <option key={k} value={item.meetingNo}>
                                            {item.meetingNo}
                                        </option>
                                    ))}
                                </Input>

                            </div>
                            <div className="d-flex align-items-center justify-content-start w-50 mx-1">
                                <span className="w-75 text-center">ปี</span>
                                <Input
                                    name="meetingYear"
                                    type="select"
                                    className="text-center w-100 rounded-pill input-color"
                                    onChange={(e) => {
                                        formikSelect.handleChange(e)
                                        setMeetingYear(e.target.value)
                                    }}
                                    onBlur={formikSelect.handleBlur}
                                    value={formikSelect.values.meetingYear}
                                >

                                    <option defaultValue={"กรุณาเลือก"}>
                                        กรุณาเลือก
                                    </option>
                                    {meetingYearSelect.map((year, i) => (
                                        <option key={i} value={year.meetingYear}>
                                            {year.meetingYear}
                                        </option>
                                    ))}
                                </Input>

                            </div>
                            <div className="d-flex align-items-center justify-content-start w-50 mx-1">
                                <span className="w-50 text-center">วันที่</span>
                                <Field name="meetingDate">
                                    {({ field, meta, form }) => {
                                        return (
                                            <DatePicker
                                                selected={field.value ? new Date(field.value) : null}
                                                locale="th-buddhist"
                                                showIcon
                                                calendarClassName="thai-buddhist"
                                                dateFormat="dd MMMM yyyy"
                                                value={ConvertDateToThaiBuddhist(field.value)}
                                                isClearable={true}
                                                placeholderText="กรุณาเลือก"
                                                renderCustomHeader={RenderCustomHeader}
                                                onChange={(date) => {
                                                    form.setFieldValue(field.name, ConvertDateFormat(date))
                                                    setMeetingDate(ConvertDateFormat(date))
                                                }}
                                                customInput={
                                                    <Input
                                                        type="text"
                                                        className={
                                                            formikSelect.touched.meetingDate && formikSelect.errors.meetingDate
                                                                ? "input-error rounded-pill text-center input-color custom-placeholder"
                                                                : "rounded-pill text-center input-color custom-placeholder"
                                                        }
                                                        value={ConvertDateToThaiBuddhist(field.value)}
                                                        onChange={() => { }}
                                                        onBlur={field.onBlur}
                                                    />
                                                }
                                            />
                                        )
                                    }}
                                </Field>


                            </div>
                        </Form>
                    </Container>

                )
            }}
        </Formik>
    )
}